import { dashboardRequest } from "../../providers/aws/client";
import { parseArtifact, parsePage, type Section } from "./contracts";

export type PageRequest = {
  sessionId: string;
  workload?: string;
  section: Section;
  cursor?: string;
  assetId?: string;
};
export function spatialPath(sessionId: string) {
  return `/video-sessions/${encodeURIComponent(sessionId)}/spatial`;
}
export async function fetchEvidence(
  request: PageRequest,
  signal?: AbortSignal,
) {
  const query = new URLSearchParams({ section: request.section });
  if (request.workload) query.set("workload", request.workload);
  if (request.cursor) query.set("cursor", request.cursor);
  if (request.assetId) query.set("asset", request.assetId);
  return parsePage(
    await dashboardRequest<unknown>(
      `${spatialPath(request.sessionId)}?${query}`,
      { signal },
    ),
    request,
  );
}
export async function fetchArtifact(
  request: {
    sessionId: string;
    workload?: string;
    revision: string;
    sha256: string;
  },
  signal?: AbortSignal,
) {
  const query = new URLSearchParams({ revision: request.revision });
  if (request.workload) query.set("workload", request.workload);
  return parseArtifact(
    await dashboardRequest<unknown>(
      `${spatialPath(request.sessionId)}/artifacts/${encodeURIComponent(request.sha256)}?${query}`,
      { signal },
    ),
    request,
  );
}
